import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import "../Assets/Styles/Style.css";
import CardSummary from "../utils/Card/CardSummary";
import useApi from "../utils/useApi";
import PrintComponent from "./manage/PrintComponent";
import ContactCsvUploader from "./manage/ContactCsvUploader";
import CsvUploader from "./manage/CsvUploader";
const HomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
    setIsOpen(false);
  };
  const handleToggle = () => {
    setIsOpen(!isOpen);
    setIsFormOpen(false);
  };
  const {Get} = useApi();
  const [data, setData] = useState();
  const fetchData = async () => {

      const result = await Get('user');
      setData(result.results);

  };
useEffect(()=>{
  fetchData();
},[])
  return (
    <main className="home-page">
      <PrintComponent/>
      <Box className="home-content">
          <div className="home-welcome">
            <div>
              <Typography className="eyebrow">OVERVIEW</Typography>
              <Typography variant="h4">Good to see you, admin.</Typography>
              <Typography className="home-subtitle">Here’s the latest snapshot of your investment operations.</Typography>
            </div>
            <div className="home-status"><span /> All systems operational</div>
          </div>
          <div className="dashboard-summary">
            <CardSummary
              cards={[
                {
                  title: "User",
                  dataKey: "total_users",
                  image: "./assets/img/users.png",
                },
                {
                  title: "Total Groups",
                  dataKey: "total_groups",
                  image: "./assets/img/Groups.png",
                },
                {
                  title: "Subscriptions",
                  dataKey: "total_subscriptions",
                  image: "./assets/img/subscribe.png",
                },
                {
                  title: "Investments",
                  dataKey: "total_invested",
                  image: "./assets/img/total-subscription.png",
                },
                {
                  title: "Penalty",
                  dataKey: "total_penalty",
                  image: "./assets/img/penalty-card.png",
                },
              ]}
            />
          </div>
          <div className="home-section-heading">
            <div><Typography variant="h6">Data operations</Typography><Typography>Import and update records securely.</Typography></div>
            <Typography className="section-caption">CSV tools</Typography>
          </div>
          <div className="upload-grid">
            <CsvUploader />
            <ContactCsvUploader />
          </div>
        </Box>
    </main>
  );
};
export default HomePage;
